import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useTheme } from 'vuetify'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToggleTheme',
  setup(__props) {

const theme = useTheme()

function toggleTheme() {
  const current = theme.global.name.value
  const newTheme = current === 'dark' ? 'light' : 'dark'

  theme.global.name.value = newTheme
  localStorage.setItem("isDarkTheme", (newTheme === "dark").toString())
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    icon: "",
    onClick: toggleTheme
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_icon, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("mdi-theme-light-dark")
        ])),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})